import { motion } from "framer-motion";
import { Button } from "./button";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface BackButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
  variant?: "default" | "ghost" | "outline";
  size?: "default" | "sm" | "lg" | "icon";
}

export const BackButton = ({ 
  onClick, 
  label,
  className,
  variant = "ghost",
  size = "sm"
}: BackButtonProps) => {
  const { t } = useTranslation();
  const displayLabel = label ?? t('common.back');
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: 1 }}
    >
      <Button
        variant={variant}
        size={size}
        onClick={onClick}
        className={cn("bg-background/80 backdrop-blur-sm shadow-md", className)}
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        {displayLabel}
      </Button>
    </motion.div>
  );
};
